import { IPromoBank } from '../../../../../types/newbuildingPromos';

export const getBankLogoUrl = (bank: IPromoBank): string | null => {
  return bank.secondSquareImageUrl || bank.logoUrl || null;
};
